import Vue from '../../../lib/utils/vue3compat/vue.js?vue3';
import VueRouter from '../../../lib/utils/vue3compat/vue_router.js?vue3';
import { createRoutes } from './routes.js?vue3';

Vue.use(VueRouter);

export const createRouter = (base, listComponent) => {
  return new VueRouter({
    base,
    mode: 'history',
    routes: createRoutes(listComponent),
  });
};
